import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useUser from 'hooks/userHooks';
import Home from '../pages/Home';

/**
 * V2IndexRedirect component that redirects agency 36 users to inbox
 * and shows Home component for other agencies
 */
const V2IndexRedirect = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useUser();

  useEffect(() => {
    // Don't redirect while loading user data
    if (isLoading || !user) {
      return;
    }

    // Redirect agency 36 (Graham Healthcare Group) to inbox
    if (user.agency_id === 36) {
      navigate('/retention/V2/inbox', { replace: true });
    }
  }, [user, isLoading, navigate]);

  // Don't render Home component if we're redirecting agency 36
  if (!isLoading && user && user.agency_id === 36) {
    return null; // Don't render anything while redirecting
  }

  // For all other agencies, show the Home component
  return <Home />;
};

export default V2IndexRedirect; 